import { authStoreUserTournamentId } from 'modules/auth/store/selectors';
import { usePlayers } from 'modules/organizer/ui/hooks/use-players';
import { Team } from 'modules/teams/domain/interfaces/team';
import { getTeamPlayers } from 'modules/teams/store/players/actions';
import { useEntryRequests } from 'modules/teams/ui/hooks/use-entry-requests';
import { mapTeamPlayerToTournamentUser } from 'modules/tournaments/domain/data-mappers/championship-game-teams-mapper';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Route, Routes } from 'react-router-dom';
import { toast } from 'react-toastify';
import EditTeam from '../components/edit-team';
import TeamsComponentsFormParticipantsListPart from '../components/form-parts/participants/participants-list';

import CreatePlayer from '../components/form-parts/players/create-player';
import TeamsComponentsFormPlayersListPart from '../components/form-parts/players/players-list';
import WaitingList from '../components/form-parts/waiting-list/waiting-list';

type Props = {
  team: Team;
  isLoading?: boolean;
};

const TeamComponentsEditForm = (props: Props) => {
  const dispatch = useDispatch();
  const userTournamentId = useSelector(authStoreUserTournamentId);

  const { team, isLoading } = props;

  useEffect(() => {
    if (team?.id) {
      dispatch(getTeamPlayers(team?.id));
    }
  }, [dispatch, team]);

  const { info: players, isGettingPlayers } = usePlayers();
  const { entryRequests, isLoading: isLoadingEntryRequests } = useEntryRequests(team.id);
  if (isLoading || (isGettingPlayers && players.length === 0) || isLoadingEntryRequests) {
    return (
      <div className="flex">
        <div className={'w-full'} style={{ marginRight: 24 }}>
          <div className="skeleton-block" style={{ width: '100%', height: 67 }} />
          <div className="skeleton-block" style={{ width: '100%', height: 67, marginTop: 16 }} />
        </div>
        <div className="skeleton-block" style={{ width: '100%', height: 348, marginLeft: 24 }} />
      </div>
    );
  }

  if (!userTournamentId) {
    toast.error('Не удалось определить активный турнир, перезагрузите страницу');
    return null;
  }

  return (
    <Routes>
      <Route
        path="players"
        element={<TeamsComponentsFormPlayersListPart teamId={team.id} players={players.filter((player) => !player.isReal)} />}
      />
      <Route path="players/create" element={<CreatePlayer tournamentId={userTournamentId} teamId={team.id} />} />
      <Route
        path="participants"
        element={
          <TeamsComponentsFormParticipantsListPart
            teamId={team.id}
            participants={players.filter((player) => player.isReal).map(mapTeamPlayerToTournamentUser)}
          />
        }
      />
      <Route
        path="waiting-list"
        element={<WaitingList entryRequests={entryRequests.filter((entryRequest) => entryRequest.status === 'CREATED')} />}
      />
      <Route path="*" element={<EditTeam team={team} tournamentId={userTournamentId} />} />
    </Routes>
  );
};

export default TeamComponentsEditForm;
